import { Row } from '@tanstack/react-table';
import { ToDoRowModel } from '../entities/Entities';
import { Konflikt } from '../entities/Konflikt';

export function sortMitarbeiter(
  rowA: Row<ToDoRowModel>,
  rowB: Row<ToDoRowModel>,
): number {
  let mitarbeiterNameA = '';
  let mitarbeiterNameB = '';

  if (rowA.original instanceof Konflikt) {
    mitarbeiterNameA =
      rowA.original.rootArbeitszeit.mitarbeiter.vorname +
      rowA.original.rootArbeitszeit.mitarbeiter.nachname;
  } else {
    mitarbeiterNameA =
      rowA.original.mitarbeiter.vorname + rowA.original.mitarbeiter.nachname;
  }

  if (rowB.original instanceof Konflikt) {
    mitarbeiterNameB =
      rowB.original.rootArbeitszeit.mitarbeiter.vorname +
      rowB.original.rootArbeitszeit.mitarbeiter.nachname;
  } else {
    mitarbeiterNameB =
      rowB.original.mitarbeiter.vorname + rowB.original.mitarbeiter.nachname;
  }

  return mitarbeiterNameA.localeCompare(mitarbeiterNameB);
}

export function filterMitarbeiter(
  row: Row<ToDoRowModel>,
  _value: string,
  filterValue: string,
): boolean {
  if (row.original instanceof Konflikt) {
    const name =
      row.original.rootArbeitszeit.mitarbeiter.vorname +
      row.original.rootArbeitszeit.mitarbeiter.nachname;
    return name.toLocaleLowerCase().includes(filterValue.toLocaleLowerCase());
  }
  const name =
    row.original.mitarbeiter.vorname + row.original.mitarbeiter.nachname;
  return name.toLocaleLowerCase().includes(filterValue.toLocaleLowerCase());
}
